import React from 'react';
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
import Router from './pages/router.jsx';
import Header from './component/header.jsx';
import '@/styles/extends.css';

function App() {
	return (
		<div className='app-content'>
			{/* <div className='h-container'><Header /></div> */}
			<Router />
		</div>
	);
}

export default App;
